module.exports = __webpack_public_path__ + "c6c4ad175d0174aaa21b5c4781940820.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_staff_3.png
// module id = 188
// module chunks = 0